<template>
    <el-date-picker
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :value-format="valueFormat"
        @change="handleChange"
        :clearable="clearable"
        style="width: 100%;"
    >
    </el-date-picker>
</template>

<script>
export default {
    name: 'DateRangePicker',
    props: {
        startDate: {
            type: String,
            default: ''
        },
        endDate: {
            type: String,
            default: ''
        },
        valueFormat: {
            type: String,
            default: 'yyyy-MM-dd'
        },
        clearable: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            dateRange: []
        };
    },
    watch: {
        startDate(val) {
            this.updateDateRange();
        },
        endDate(val) {
            this.updateDateRange();
        }
    },
    mounted() {
        this.updateDateRange();
    },
    methods: {
        updateDateRange() {
            if (this.startDate && this.endDate) {
                this.dateRange = [this.startDate, this.endDate];
            } else {
                this.dateRange = [];
            }
        },
        handleChange(val) {
            if (val && val.length === 2) {
                this.$emit('update:startDate', val[0]);
                this.$emit('update:endDate', val[1]);
            } else {
                this.$emit('update:startDate', '');
                this.$emit('update:endDate', '');
            }
        }
    }
};
</script>
